namespace SaSpinnerUtils {
    const canonicalFullPageSpinnerSelector = "#saFullPageSpinner";
    const legacyFullPageSpinnerSelector = ".spinner-overlay";

    function getFullPageSpinner(selector?: string) {
        if (selector) {
            return $(selector).first();
        }

        const spinner = $(canonicalFullPageSpinnerSelector).first();
        if (spinner.length > 0) {
            return spinner;
        }

        return $(legacyFullPageSpinnerSelector).first();
    }

    export function ShowFullPageSpinner(selector?: string): void {
        const spinner = getFullPageSpinner(selector);
        if (spinner.length > 0) {
            spinner.show();
        }
    }

    export function HideFullPageSpinner(selector?: string): void {
        const spinner = getFullPageSpinner(selector);
        if (spinner.length > 0) {
            spinner.hide();
        }
    }

    export function ShowSectionSpinner(selector: string): void {
        const spinner = $(selector).first();
        if (spinner.length > 0) {
            spinner.show();
        }
    }

    export function HideSectionSpinner(selector: string): void {
        const spinner = $(selector).first();
        if (spinner.length > 0) {
            spinner.hide();
        }
    }
}

globalThis.SaSpinnerUtils = SaSpinnerUtils;
